import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Layout, Grid } from 'antd'
import { useTheme } from 'styled-components'
import LocaleContext from '../utils/LocaleContext'
import { locales } from '../utils/locales'

const { Content } = Layout
const { useBreakpoint } = Grid

// TODO if changes for the wrapping container needs to be done, this is here!

const TestLayout = ({ children }) => {
  const { language, setLanguage } = useContext(LocaleContext)
  const theme = useTheme()
  const screens = useBreakpoint()
  const mobile = !screens.lg
  const containerWidth = 1024

  useEffect(() => {
    const { lang } = document.documentElement
    console.log('<html> tag language', lang)
    if (lang && (lang === 'de' || lang === 'en') && lang !== language) {
      setLanguage(locales[lang])
    }
  }, [language, setLanguage])

  return (
    <Layout style={{ maxWidth: containerWidth, margin: '0 auto' }}>
      <Content
        style={{ padding: mobile ? '20px 12px' : '32px 44px', backgroundColor: theme.colorWhite }}
      >
        {children}
      </Content>
    </Layout>
  )
}

TestLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default TestLayout
